import {roleSystemRoute} from './route_utilities'

import Audit from '../../views/audits/Audit.vue'
import AuditCover from '../../views/audits/AuditCover.vue'
import AuditDocuments from '../../views/audits/AuditDocuments.vue'
import AuditQuestionList from '../../views/audits/AuditQuestionList.vue'
import AuditQuestionListSection from '../../views/audits/AuditQuestionListSection.vue'
import AuditActionPlan from '../../views/audits/AuditActionPlan.vue'
import AuditActionPlanItem from '../../views/audits/AuditActionPlanItem.vue'
import AuditReport from '../../views/audits/AuditReport.vue'




export const audits = {
	path: 'audit/:audit_uuid',
	name: 'Audit',
	component: Audit,
	redirect:{
		name:AuditCover
	},
	meta: {
		title: "denetlemeler",
		domain:"audits"
	},
	children:[
	{
		path: 'cover',  
		name: 'AuditCover',
		component: AuditCover,
		meta: {
			title: "denetleme_ozeti",
			preloader:true,
			domain:"auditor_audits"
		},
	},
	{
		path: 'documents',  
		name: 'AuditDocuments',
		component: AuditDocuments,
		meta: {
			title: "firma_belgeleri",
			preloader:true,
			domain:"auditor_audits"
		},
	},
	{
		path: 'questionlist',  
		name: 'AuditQuestionList',
		component: AuditQuestionList,
		meta: {
			title: "sorular",
			preloader:true,
			domain:"auditor_audits"
		},
	},
	{
		path: 'section/:section_id',  
		name: 'AuditQuestionListSection',
		component: AuditQuestionListSection,
		meta: {
			title: "bolum",
			preloader:true,
			domain:"auditor_audits"
		},
	},
	{
		path: 'action_plan',  
		name: 'AuditActionPlan',
		component: AuditActionPlan,
		meta: {
			title: "aksiyon_plani",
			preloader:true,
			domain:"auditor_audits"
		},
	},
	{
		path: 'nonconformity/:nonconformity_id',  
		name: 'AuditActionPlanItem',
		component: AuditActionPlanItem,
		meta: {
			title: "uygunsuzluk",
			preloader:true,
			domain:"auditor_audits"
		},
	},
	{
		path: 'report',  
		name: 'AuditReport',
		component: AuditReport,
		meta: {
			title: "denetleme_raporu",
			preloader:true,
			domain:"auditor_audits"
		},
	},
	]
}